<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="aut/letter/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { Letter } from '@/modules/aut/data/letter/create'
	import { LetterService } from '@/modules/aut/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return Letter;
			},

			service()
			{
				return new LetterService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>